// extracted by mini-css-extract-plugin
export var activeDot = "_4y-c";
export var buttonContainer = "_4y-9";
export var channelButton = "_4y-a";
export var clickable = "_4y-d";
export var content = "_4y-0";
export var contentFull = "_4y-2";
export var contentThird = "_4y-1";
export var contentWrapper = "_4y-7";
export var description = "_4y-5";
export var heightShort = "_4y-f";
export var image = "_4y-3";
export var imageContainer = "_4y-4";
export var selectButton = "_4y-e";
export var spinnerContainer = "_4y-b";
export var titleContent = "_4y-8";
export var titleWrapper = "_4y-6";